import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Chip: the kit's citation chip (wp-cite) and suggestion chip (wp-btn--chip). Both are buttons: a
// citation opens its source in a popover (E09-S3-T3), a suggestion sends what it carries. Pass a chip
// as a Radix trigger with asChild on the trigger; the ref reaches the button (React 19 ref as a prop).
//
// The kit draws the citation 20 px tall; here it is 24 px, the WCAG 2.2 minimum target for a control.
import { cva } from "class-variance-authority";
import { Glyph } from "./button.js";
import { cn, focusRing, minTarget } from "./cn.js";
export const chipVariants = cva([
    "inline-flex shrink-0 cursor-pointer items-center whitespace-nowrap border font-sans leading-none",
    "transition duration-fast ease-wp disabled:pointer-events-none disabled:opacity-45",
    minTarget,
    focusRing,
], {
    variants: {
        variant: {
            citation: [
                "h-6 rounded-4 border-wp-line-strong bg-wp-bg/58 text-11 font-semibold tabular-nums",
                "text-wp-text-2 hover:border-wp-accent/44 hover:text-wp-text [&>[aria-hidden]]:text-wp-text-3",
            ],
            suggestion: [
                "rounded-pill border-wp-accent/44 bg-wp-accent/13 font-medium text-wp-text",
                "hover:border-wp-accent hover:bg-wp-accent/22",
            ],
        },
        compact: { false: "", true: "" },
    },
    compoundVariants: [
        { variant: "citation", compact: false, className: "gap-1 pl-1.5 pr-2" },
        { variant: "citation", compact: true, className: "gap-0.5 px-1" },
        { variant: "suggestion", compact: false, className: "h-8 gap-1.5 px-3 text-13" },
        { variant: "suggestion", compact: true, className: "h-7 gap-1 px-2.5 text-12" },
    ],
    defaultVariants: { variant: "suggestion", compact: false },
});
export function Chip({ className, variant, compact, icon, type = "button", children, ...props }) {
    return (_jsxs("button", { type: type, "data-variant": variant ?? "suggestion", "data-compact": compact ?? false, className: cn(chipVariants({ variant, compact }), className), ...props, children: [icon ? _jsx(Glyph, { children: icon }) : null, children] }));
}
//# sourceMappingURL=chip.js.map